// extracted by mini-css-extract-plugin
module.exports = {"footnotes":"Footnotes_footnotes__S1jYQ"};